module.exports = __webpack_public_path__ + "static/media/achievement-astro-boots.253979d0.svg";